module.exports = __webpack_public_path__ + "static/media/reedITaki1028.f2217a4e.ico";